// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
    padding-top: 40px;
}

#goBackLink {
    color: var(--main-color);
    margin-left: -16px;
    margin-bottom: 10px;
}

    #goBackLink:hover {
        color: var(--main-color);
        cursor: pointer;
    }

.no-job-msg {
    padding-top: 75px;
}

.jobCategoryChip {
    margin: 10px 5px;
}

.disableEvent{
    pointer-events: none;
}


@media (min-width: 768px) and (max-width: 991px) {
    .col-md-3 {
        flex: 0 0 100%;
        max-width: 100%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/components/job/jobdetails.component.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,mBAAmB;AACvB;;IAEI;QACI,wBAAwB;QACxB,eAAe;IACnB;;AAEJ;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;;;AAGA;IACI;QAEI,cAAc;QACd,eAAe;IACnB;AACJ","sourcesContent":[".container {\r\n    padding-top: 40px;\r\n}\r\n\r\n#goBackLink {\r\n    color: var(--main-color);\r\n    margin-left: -16px;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n    #goBackLink:hover {\r\n        color: var(--main-color);\r\n        cursor: pointer;\r\n    }\r\n\r\n.no-job-msg {\r\n    padding-top: 75px;\r\n}\r\n\r\n.jobCategoryChip {\r\n    margin: 10px 5px;\r\n}\r\n\r\n.disableEvent{\r\n    pointer-events: none;\r\n}\r\n\r\n\r\n@media (min-width: 768px) and (max-width: 991px) {\r\n    .col-md-3 {\r\n        -ms-flex: 0 0 100%;\r\n        flex: 0 0 100%;\r\n        max-width: 100%;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
